import {
Form,
FormItem,
Input,
InputNumber,
Button,
Loading,
Collapse,
CollapseItem,
Select,
Option,
DatePicker,
Upload,
Autocomplete,

Dialog,
Row,
Col,
RadioGroup,
RadioButton,
Pagination,
Progress,
} from 'element-ui'

import VueClipboard from 'vue-clipboard2'
import VueLazyload from 'vue-lazyload'

import ToastPlugin from 'vux/src/plugins/toast/index.js'
import Confirm from 'vux/src/components/confirm/index.vue'
import dateFormat from 'vux/src/tools/date/format.js'
import Datetime from 'vux/src/components/datetime/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Icon from 'vux/src/components/icon/index.vue'
import Qrcode from 'vux/src/components/qrcode/index.vue'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'
import Badge from 'vux/src/components/badge/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Divider from 'vux/src/components/divider/index.vue'
import Picker from 'vux/src/components/picker/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import InlineLoading from 'vux/src/components/inline-loading/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Countdown from 'vux/src/components/countdown/index.vue'
import AlertModule from 'vux/src/plugins/alert/module'
import Countup from 'vux/src/components/countup/index.vue'


function plugin(Vue) {
if (plugin.installed) {
return
}

Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(InputNumber)
Vue.use(Button)
Vue.use(Loading.directive)
Vue.prototype.$loading = Loading.service
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(Select)
Vue.use(Option)
Vue.use(DatePicker)
Vue.use(Upload)
Vue.use(Autocomplete);

Vue.use(Dialog)
Vue.use(Row)
Vue.use(Col)
Vue.use(RadioGroup)
Vue.use(RadioButton)
Vue.use(Pagination)
Vue.use(Progress)

Vue.use(VueLazyload)
Vue.use(VueClipboard)


Vue.use(ToastPlugin, {
position: 'middle',
width: '12rem',
time: 3500
});
Vue.component('confirm', Confirm)
Vue.prototype.$showToast = function(obj = {}) {
let params = {
position: 'middle',
showPositionValue: true,
text: '提示信息！',
type: 'cancel',
width: '12rem',
time: 3500
}
params = Object.assign({}, params, obj)
this.$vux.toast.show(params)
}
Vue.component('dateFormat', dateFormat)
Vue.component('Datetime', Datetime)
Vue.component('XHeader', XHeader)
Vue.component('x-button', XButton)
Vue.component('Icon', Icon)
Vue.component('Qrcode', Qrcode)
Vue.component('Checker', Checker)
Vue.component('CheckerItem', CheckerItem)
Vue.component('Cell', Cell)
Vue.component('Badge', Badge)
Vue.component('Divider', Divider)
Vue.component('Picker', Picker)
Vue.component('popup-picker', PopupPicker)
Vue.component('x-dialog', XDialog)
Vue.component('Popup', Popup)
Vue.component('Group', Group)
Vue.component('Flexbox', Flexbox)
Vue.component('FlexboxItem', FlexboxItem)
Vue.component('x-input', XInput)
Vue.component('InlineLoading', InlineLoading)
Vue.component('Tab', Tab)
Vue.component('TabItem', TabItem)
Vue.component('Countdown', Countdown)
Vue.component('Countup', Countup)
Vue.directive('transfer-dom', TransferDom)

function alert({
title,
content,
buttonText = this.$t('others').confirm,
hideOnBlur = true,
open = Function,
close = Function
}) {
AlertModule.show({
title, // 标题
content, // 内容
buttonText, // 弹框按钮
hideOnBlur, // 点击遮罩层关闭
onShow() { // 弹框打开的回调事件
open()
},
onHide() { // 弹框关闭的回调事件
close()
}
})
}
Vue.prototype.$alert = alert
}

export default plugin



// WEBPACK FOOTER //
// ./src/pages/build821/utils/global-ui.js